import { get, flow } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getItemSkuLookup = get('inventory.components.itemSkuLookup');

export const getItemSku = createSelector(getItemSkuLookup, get('itemSku'));

export const getIsFetching = flow(
  getItemSkuLookup,
  get('fetching')
);

export const getIsFetched = flow(
  getItemSkuLookup,
  get('fetched')
);

export const getShowAddItemSkuModal = flow(
  getItemSkuLookup,
  get('showAddItemSkuModal')
);
